import _ from 'lodash';
import toast from 'react-hot-toast';
import {
    RequestState,
    ModalTypes,
    WalletConnectionTypes,
    WalletConnectProjectId,
    NetworkInfoByChainId,
    CurrentNetwork,
    CurrentNetworkInfo,
    SubchainId,
    ContractAddresses,
    ValidatorStakeManagerContract,
    GovernanceTokenContract,
    ChainRegistrarOnMainchainContract,
    STAKING_DISABLED,
    SubchainGovernanceTokenSymbol,
    SubchainStakingRewardPerYear,
    WalletConnectMetadata,
    CLAIMING_DISABLED,
    NFTContract,
    ClaimingContract,
    ClaimableAirdropCheckerContract,
    CollectibleNamesByAddress,
    ClaimingContractByNFTToBurn,
    BalanceCheckerContract, ThetaSwap, GroveWarsStoreContract, GroveWarsClaimableAirdropContract
} from "../../constants";
import {BigNumber, ethers, FixedNumber, providers} from "ethers";
import WalletConnectProvider from "@walletconnect/web3-provider";
import * as thetajs from '@thetalabs/theta-js';
import {store} from "../index";
import UIState from "../uiState";
import {Button} from "../../components/Button";
import {formatBalance, getTimestampAtBlock, storeProductToObject, truncateToDigits} from "../../utils";
import {EthereumProvider} from '@walletconnect/ethereum-provider'
import storage from "../../utils/storage";
import {fromWei, toWei} from "@thetalabs/theta-js/src/utils";
import Items, {getAllItemContractAddresses} from "../../items";
import Airdrops from "../../airdrops";

const getReduxState = () => {
    return store.getState();
}

// ===========================
// HELPERS
// ===========================

export const getGroveContract = (providerOrSigner) => {
    const address = ContractAddresses.GroveToken;
    const abi = GovernanceTokenContract.abi;
    return new ethers.Contract(address, abi, providerOrSigner);
}

export const getGroveWarsStoreContract = (providerOrSigner) => {
    const address = ContractAddresses.GroveWarsStore;
    const abi = GroveWarsStoreContract.abi;
    return new ethers.Contract(address, abi, providerOrSigner);}

const buildDefaultProvider = () => {
    const providerRPC = {
        name: CurrentNetworkInfo.chainId,
        rpc: CurrentNetworkInfo.ethRpc,
        chainId: CurrentNetworkInfo.chainIdNum,
    };
    const provider = new providers.JsonRpcProvider(
        providerRPC.rpc,
        {
            chainId: providerRPC.chainId,
            name: `theta-${providerRPC.name}`,
        }
    );

    return provider;
}

const getBalanceTotals = async (provider, addresses, contractAddresses) => {
    const balanceChecker = new ethers.Contract(ContractAddresses.BalanceChecker, BalanceCheckerContract.abi, provider);
    const balances = await balanceChecker.balances(addresses, contractAddresses);
    console.log('getBalanceTotals :: addresses == ', addresses);
    console.log('getBalanceTotals :: contractAddresses == ', contractAddresses);
    console.log('balances', balances);


    // contract returns a array of length addresses.length * tokens.length so we need to partiton it
    const balancesGroupedByAddress = _.chunk(balances, contractAddresses.length);

    return _.reduce(balancesGroupedByAddress, (current, balanceGroup) => {
        return _.reduce(balanceGroup, (current2, balance, balanceIdx) => {
            const contractAddress = contractAddresses[balanceIdx];
            return _.update(current2, contractAddress, (contractBalance) => {
                return (contractBalance || 0) + parseInt(balance.toString());
            });
        }, current);
    }, {});
}

async function switchEthereumChain(chainId) {
    try {
        await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{chainId: chainId}],
        });
    } catch (e) {
        if (e.code === 4902) {
            try {
                await window.ethereum.request({
                    method: 'wallet_addEthereumChain',
                    params: [
                        {
                            chainId: '0x169', // 361 in decimal
                            chainName: 'Theta Mainnet',
                            nativeCurrency: {
                                name: 'TFUEL',
                                symbol: 'TFUEL',
                                decimals: 18
                            },
                            blockExplorerUrls: ['https://explorer.thetatoken.org'],
                            rpcUrls: ['https://eth-rpc-api.thetatoken.org/rpc'],
                        },
                    ],
                });
            } catch (addError) {
                console.error(addError);
            }
        }
        console.error(e)
    }
}

const isMobileBrowser = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export const createWalletConnectV2Provider = async (dispatch) => {
    const wcProvider = await EthereumProvider.init({
        projectId: WalletConnectProjectId,
        chains: [`${NetworkInfoByChainId[CurrentNetwork].chainIdNum}`],
        showQrModal: !isMobileBrowser(),
        rpcMap: {
            ["361"]: NetworkInfoByChainId['mainnet'].ethRpc,
            ["365"]: NetworkInfoByChainId['testnet'].ethRpc,
            ["366"]: NetworkInfoByChainId['privatenet'].ethRpc,
        },
        metadata: WalletConnectMetadata
    });

    wcProvider.on("connect", (event) => {
        console.log("connect wc", event);
    });
    wcProvider.on("disconnect", (event) => {
        console.log("disconnect wc", event);
        //TODO logout
        dispatch(Wallet.actions.disconnect());
    });
    wcProvider.on("chainChanged", (event) => {
        console.log("chainChanged wc", event)
    });
    wcProvider.on("accountsChanged", (event) => {
        console.log("accountsChanged wc", event)
    });
    wcProvider.on('display_uri', (uri) => {
        if (isMobileBrowser()) {
            dispatch(UIState.actions.showModal(ModalTypes.ConnectWallet, {
                uri: uri,
            }));
        }
    });

    return wcProvider;
}

function getValidatorAddressForAccount(address, validators) {
    validators = _.sortBy(validators, (v) => v);
    return _.first(validators);
}

async function getValidatorAddresses(chainRegistrarOnMainchainContract) {
    const {dynasty} = await chainRegistrarOnMainchainContract.getDynasty();
    const {
        validators,
        shareAmounts
    } = await chainRegistrarOnMainchainContract.getValidatorSet(SubchainId, dynasty);
    console.log('validators', validators);
    console.log('shareAmounts', shareAmounts);

    return validators;
}

const showLoader = (title, subtitle) => {
    store.dispatch(UIState.actions.showLoader(title, subtitle));
}

const sleepUntil = async (f, timeoutMs) => {
    return new Promise((resolve, reject) => {
        const timeWas = new Date();
        const wait = setInterval(function () {
            if (f()) {
                console.log("resolved after", new Date() - timeWas, "ms");
                clearInterval(wait);
                resolve();
            } else if (new Date() - timeWas > timeoutMs) { // Timeout
                console.log("rejected after", new Date() - timeWas, "ms");
                clearInterval(wait);
                reject();
            }
        }, 20);
    });
}

const wrapSendTransaction = async (transactionSenderFn) => {
    const state = getReduxState();
    const loginType = selectLoginType(state);
    const provider = selectProvider(state);

    if (provider.readonly !== true) {
        let appSuffix = '';
        if (loginType === WalletConnectionTypes.ThetaWallet) {
            appSuffix = '\non your Theta Wallet app';
        } else if (loginType === WalletConnectionTypes.MetaMask) {
            appSuffix = '\non MetaMask';
        }
        showLoader('Pending...', `Please review and sign the transaction${appSuffix}.`);
        const txResponse = await transactionSenderFn();
        showLoader('Waiting...', 'Transaction is being processed.');
        await txResponse.wait(2);
    }
}

export const showApprovalModal = async (title, body) => {
    let hasResponded = false;
    let approved = false;
    const onClose = () => {
        hasResponded = true;
    };
    const onApprove = () => {
        store.dispatch(UIState.actions.hideModal());
        hasResponded = true;
        approved = true;
    };
    const onReject = () => {
        store.dispatch(UIState.actions.hideModal());
        hasResponded = true;
    };
    store.dispatch(UIState.actions.showModal(ModalTypes.Alert, {
        title: title,
        body: body,
        buttons: [
            <Button color={'grey'}
                    size={'medium'}
                    style={{width: 140}}
                    onClick={onReject}
            >
                Cancel
            </Button>,
            <Button
                color={'brand'}
                size={'medium'}
                style={{width: 140}}
                onClick={onApprove}
            >
                Continue
            </Button>
        ],
        onClose: onClose,
    }));
    await sleepUntil(() => {
        return hasResponded === true;
    }, 60000);

    return approved;
}

export const checkNFTApproval = async (contract, owner, spender, contractName) => {
    showLoader('Checking NFT approval...');

    const isApproved = await contract.isApprovedForAll(owner, spender);
    if (!isApproved) {
        const body = `This action requires your approval to burn your ${contractName} NFTs.`;
        const approved = await showApprovalModal('Approval Required', body);

        // Approve all
        if (approved) {
            showLoader('Requesting NFT approval...', 'Please review and sign the transaction.');
            const txResponse = await contract.setApprovalForAll(spender, true);
            showLoader('Waiting...', 'NFT Approval transaction is being processed.');
            await txResponse.wait(2);
        } else {
            throw Error('Did not approve');
        }
    }
}

export const checkTokenApproval = async (contract, owner, spender, amount) => {
    showLoader('Checking allowance...');
    const allowance = await contract.allowance(owner, spender);
    if (allowance.lte(amount)) {
        // Approve all
        showLoader('Allowance required', '(Transaction 1/2)\nPlease review and sign the transaction.');

        const txResponse = await contract.approve(spender, ethers.utils.parseEther('1000000000'));
        showLoader('Waiting...', 'Transaction is being processed.');
        await txResponse.wait(2);
    }
}

export const checkTokenBalance = async (contract, owner, amount) => {
    showLoader('Checking balance...');
    const balance = await contract.balanceOf(owner);
    if (balance.lt(amount)) {
        store.dispatch(UIState.actions.showModal(ModalTypes.Alert, {
            title: `Not enough ${SubchainGovernanceTokenSymbol}`,
            body: `This action requires a minimum balance of ${formatBalance(amount.toString())} ${SubchainGovernanceTokenSymbol}.`,
            buttons: [
                <Button
                    color={'brand'}
                    size={'large'}
                    style={{width: 132}}
                    onClick={() => {
                        store.dispatch(UIState.actions.hideModal());
                    }}
                >
                    Okay
                </Button>
            ]
        }));
        throw Error(`Not enough ${SubchainGovernanceTokenSymbol}`);
    }
}

export const getNetwork = () => {
    return thetajs.networks.Mainnet;
}

const getContractInfoByAddress = (contractAddress) => {
    // return contractInfoByAddress[contractAddress.toLowerCase()];
}


// ACTIONS
// ===========================
export const LOGIN_WITH_METAMASK = 'LOGIN_WITH_METAMASK';
export const LOGIN_WITH_THETA_DROP = 'LOGIN_WITH_THETA_DROP';
export const FINISH_LOGIN = 'FINISH_LOGIN';
export const WALLET_CONNECTION_CHANGE = 'WALLET_CONNECTION_CHANGE';
export const INIT_WALLET_COMPLETE = 'INIT_WALLET_COMPLETE';
export const SET_PROVIDER = 'SET_PROVIDER';
export const SET_NETWORK = 'SET_NETWORK';
export const SET_BALANCES = 'SET_BALANCES';
export const SET_STORE_PRODUCTS = 'SET_STORE_PRODUCTS';
export const SET_LOGIN_TYPE = 'SET_LOGIN_TYPE';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_STAKE_WITHDRAWLS = 'SET_STAKE_WITHDRAWLS';
export const SET_BLOCK_NUMBER = 'SET_BLOCK_NUMBER';
export const SET_NFT_TOKEN_IDS = 'SET_NFT_TOKEN_IDS';
export const SET_STAKING_APY = 'SET_STAKING_APY';
export const SET_PAIR_BALANCE = 'SET_PAIR_BALANCE';
export const SET_PAIR_TOKENS_BALANCE = 'SET_PAIR_TOKENS_BALANCE';
export const SET_PAIR_TOTAL_SUPPLY = 'SET_PAIR_TOTAL_SUPPLY';
export const SET_PAIR_ALLOWANCE = 'SET_PAIR_ALLOWANCE';

export const SET_AIRDROP_STATES = 'SET_AIRDROP_STATES';

// ===========================
// SELECTORS
// ===========================

export const selectStoreProducts = (state) => {
    const storeProductsByNFTContract = state.models.storeProductsByNFTContract;
    return _.map(Items, (item) => {
        return{
            ...item,
            product: storeProductsByNFTContract[item.contract_address.toLowerCase()],
        }
    });
};

export const selectAirdrops = (state) => {
    const airdropStates = state.models.airdropStates;
    console.log('airdropStates == ', airdropStates);
    return _.map(Airdrops, (item) => {
        return{
            ...item,
            state: airdropStates[item.contract_address],
        }
    });
};

export const selectStoreProductsByType = (state) => {
    const storeProducts = selectStoreProducts(state);
    return _.groupBy(storeProducts, 'type');
}

export const selectCurrentAccount = (state) => state.models.currentAccount;
export const selectProvider = (state) => state.models.provider;
export const selectBalances = (state) => state.models.balances;
export const selectNFTBalances = (state) => state.models.nftBalances;
export const selectLoginType = (state) => {
    return state.models.loginType;
};
export const selectCanSendTransactions = (state) => {
    const loginType = selectLoginType(state)
    return (loginType === WalletConnectionTypes.MetaMask || loginType === WalletConnectionTypes.ThetaWallet);
};
export const selectStakingAPY = (state) => {
    return state.models.stakingAPY;
};

export const selectTfuelGrovePair = (state) => {
    return state.models.pairs[ThetaSwap.PAIRS.TFUEL_GROVE.address];
}
export const selectAirdropStates = (state) => {
    return state.models.airdropStates;
}

export const selectAirdropState = (state, airdropContractAddress) => {
    return state.models.airdropStates[airdropContractAddress];
}

// ===========================
// MODEL
// ===========================
const Wallet = {
    actions: {
        fetchStakingAPY: () => async (dispatch, getState) => {
            const curStakingAPY = selectStakingAPY(getState());
            if(curStakingAPY > 0){
                // Only fetch once
                return;
            }

            const provider = buildDefaultProvider();
            const vsm = new ethers.Contract(ContractAddresses.VSM, ValidatorStakeManagerContract.abi, provider);
            const governanceToken = new ethers.Contract(ContractAddresses.GovernanceToken, GovernanceTokenContract.abi, provider);
            const rewardPerAnnumBN = ethers.utils.parseEther(`${SubchainStakingRewardPerYear}`);
            const stakedAmountBN = await governanceToken.balanceOf(vsm.address);
            let stakingAPY;

            // Make sure stakedAmountBN is not zero
            if (!stakedAmountBN.isZero()) {
                // Adjust for scale to prevent integer division truncation to 0
                stakingAPY = rewardPerAnnumBN.mul(ethers.constants.WeiPerEther).div(stakedAmountBN).mul(100);
                stakingAPY = stakingAPY.div(ethers.constants.WeiPerEther);
                stakingAPY = Math.floor(parseFloat(stakingAPY.toString()));
            }

            if(stakingAPY){
                dispatch({
                    type: SET_STAKING_APY,
                    stakingAPY: stakingAPY,
                });
            }
        },
        fetchNetwork: () => async dispatch => {
            let network = getNetwork();
            dispatch({
                type: SET_NETWORK,
                network
            });
        },
        disconnect: () => async dispatch => {
            await dispatch({
                type: SET_PROVIDER,
                provider: null,
            });
            await dispatch({
                type: SET_ACCOUNT,
                account: null,
            });
            storage.removeItem('walletConnectionType');
            storage.clear();
            window.location.reload();
        },
        setConnected: (connected) => async dispatch => {
            dispatch({
                type: WALLET_CONNECTION_CHANGE,
                connected,
            });
        },
        tryToRecoverWalletSession: () => async (dispatch, getState) => {
            const currentAccount = selectCurrentAccount(getState());
            if(!_.isNil(currentAccount)){
                console.log('tryToRecoverWalletSession :: skipping because account is already connected');
                return;
            }

            const walletConnectionType = storage.getItem('walletConnectionType');
            if (walletConnectionType) {
                if (walletConnectionType === WalletConnectionTypes.MetaMask) {
                    await dispatch(Wallet.actions.loginWithMetamask());
                } else if (walletConnectionType === WalletConnectionTypes.ThetaWallet) {
                    await dispatch(Wallet.actions.loginWithWalletConnect(true));
                }
            }
            else {
                // In-wallet browser - try to auto-login
                if (window.ethereum && window.ethereum.isThetaWallet) {
                    console.log('isThetaWallet!@!!!');
                    await dispatch(Wallet.actions.loginWithMetamask());
                }
            }
        },
        initMetamaskWallet: () => async (dispatch, getState) => {
            await dispatch(Wallet.actions.fetchNetwork());
        },
        loginWithMetamask: () => async (dispatch, getState) => {
            try {
                showLoader('Pending...', 'Please connect your account\non MetaMask.');
                await dispatch(Wallet.actions.initMetamaskWallet());
                const accounts = await window.ethereum.request({method: 'eth_requestAccounts'});
                console.log('loginWithMetamask :: accounts == ');
                console.log(accounts);
                const provider = new ethers.providers.Web3Provider(window.ethereum);
                console.log('loginWithMetamask :: provider == ');
                console.log(provider);
                console.log('loginWithMetamask :: window.ethereum == ');
                console.log(window.ethereum);
                window.ethereum.on('chainChanged', function (networkId) {
                    window.location.reload();
                });
                if (window.ethereum.networkVersion !== '0x169') {
                    await switchEthereumChain('0x169');
                }
                const signer = provider.getSigner();
                console.log('loginWithMetamask :: signer == ');
                console.log(signer);
                const address = await signer.getAddress();
                await dispatch({
                    type: SET_PROVIDER,
                    provider,
                });
                await dispatch({
                    type: SET_ACCOUNT,
                    account: address,
                });
                await dispatch(Wallet.actions.getBalances());
                await dispatch(Wallet.actions.getStoreProducts());
                await dispatch(Wallet.actions.getBlockNumber());


                dispatch(UIState.actions.hideModal(ModalTypes.ConnectWallet));
                dispatch(UIState.actions.hideModal(ModalTypes.Login));


                storage.setItem('walletConnectionType', WalletConnectionTypes.MetaMask);

                window.ethereum.on('accountsChanged', function (accounts) {
                    dispatch(Wallet.actions.disconnect());
                    window.location.reload();
                });
            } catch (e) {
                console.log(e);
                toast.error('Failed to connect to MetaMask');
            } finally {
                dispatch(UIState.actions.hideLoader());
            }
        },
        loginWithWalletConnect: (onlyRecoverSession) => async (dispatch, getState) => {
            try {
                const walletConnectProvider = await createWalletConnectV2Provider(dispatch);
                const handleConnect = async () => {
                    const accounts = walletConnectProvider.accounts;
                    if (!_.isEmpty(accounts)) {
                        showLoader('Pending...', 'Please authorize the app\non your Theta Wallet app.');
                        const provider = new providers.Web3Provider(walletConnectProvider);
                        const signer = provider.getSigner();
                        const address = await signer.getAddress();
                        await dispatch({
                            type: SET_PROVIDER,
                            provider,
                        });
                        await dispatch({
                            type: SET_ACCOUNT,
                            account: address,
                        });
                        storage.setItem('walletConnectionType', WalletConnectionTypes.ThetaWallet);
                        await dispatch(Wallet.actions.getBalances());
                        await dispatch(Wallet.actions.getStoreProducts());
                        await dispatch(Wallet.actions.getBlockNumber());

                        dispatch(UIState.actions.hideModal(ModalTypes.ConnectWallet));
                        dispatch(UIState.actions.hideModal(ModalTypes.Login));
                    }
                };
                if (walletConnectProvider.session &&
                    walletConnectProvider?.session?.expiry > (Date.now() / 1000) &&
                    walletConnectProvider.accounts.length > 0) {
                    // recover session?
                    await handleConnect();
                } else {
                    if (!onlyRecoverSession) {
                        await walletConnectProvider.connect();
                        await handleConnect();
                    }
                }
            } catch (e) {
                console.log(e);
                toast.error(e.message);
            } finally {
                dispatch(UIState.actions.hideLoader());
            }
        },
        maybeFinishLoginWithThetaWallet: () => async (dispatch, getState) => {
            try {
                dispatch(Wallet.actions.loginWithWalletConnect(true));
            } catch (e) {
                toast.error(e.message);
            } finally {
                dispatch(UIState.actions.hideLoader());
            }
        },
        getStoreProducts: () => async (dispatch, getState) => {
            if(ContractAddresses.GroveWarsStore === '0x0'){
                console.log('GroveWarsStore contract not set');
                return;
            }
            const provider = selectProvider(getState());
            const groveWarsStore = getGroveWarsStoreContract(provider);
            let products = await groveWarsStore.getAllProducts();
            const curBlock = await provider.getBlockNumber();

            products = products.map((product, idx) => {
                return storeProductToObject(product, curBlock);
            });

            console.log('products == ', products);

            dispatch({
                type: SET_STORE_PRODUCTS,
                products: products,
            });
        },
        getBalances: () => async (dispatch, getState) => {
            if(ContractAddresses.BalanceChecker === '0x0'){
                console.log('BalanceChecker contract not set');
                return;
            }

            const provider = selectProvider(getState());
            const signer = provider.getSigner();
            const address = await signer.getAddress();

            const contractAddresses = _.flatten([
                // Token
                ContractAddresses.GroveToken,
                // Products
                getAllItemContractAddresses()
            ]);
            const balancesByContract = await getBalanceTotals(provider, [address], contractAddresses);
            console.log('balancesByContract == ', balancesByContract);
            console.log(_.mapValues(balancesByContract, (balance) => balance.toString()));

            dispatch({
                type: SET_BALANCES,
                balances: {
                    groveTokenOnHand: balancesByContract[ContractAddresses.GroveToken].toString(),
                    governanceTokenOnHand: balancesByContract[ContractAddresses.GroveToken].toString(),
                },
                nftBalances: {
                    ...balancesByContract
                }
            });
        },
        getBlockNumber: () => async (dispatch, getState) => {
            const provider = selectProvider(getState());
            const blockNumber = await provider.getBlockNumber();

            dispatch({
                type: SET_BLOCK_NUMBER,
                blockNumber: blockNumber.toString()
            });
        },
        purchaseProduct: (product, qty = 1) => async (dispatch, getState) => {
            console.log('purchaseProduct :: product == ', product);
            try {
                showLoader('Loading...');
                const provider = selectProvider(getState());
                const signer = provider.getSigner();
                const address = await signer.getAddress();
                const grove = getGroveContract(signer);
                const groveWarsStore = getGroveWarsStoreContract(signer);
                const totalGroveWei = BigNumber.from(product.grovePrice).mul(qty);

                if(!totalGroveWei.isZero()){
                    await checkTokenBalance(grove, address, totalGroveWei);
                    await checkTokenApproval(grove, address, ContractAddresses.GroveWarsAssetManager, totalGroveWei);
                }

                await wrapSendTransaction( () => {
                    return groveWarsStore.purchaseProduct(parseInt(product.id), qty);
                });

                await dispatch(Wallet.actions.getBalances());
                await dispatch(Wallet.actions.getStoreProducts());
                await dispatch(UIState.actions.hideModal(ModalTypes.Item));

                toast.success(`Product purchased`);

                return true;
            }
            catch (e){
                toast.error(`Failed to purchase product`);
            }
            finally {
                dispatch(UIState.actions.hideLoader());
            }

        },
        fetchPairBalance(pairAddress) {
            return async (dispatch, getState) => {
                let provider = selectProvider(getState())
                const signer = provider.getSigner();
                const walletAddress = await signer.getAddress();

                if (!_.isEmpty(walletAddress)) {
                    const pairContract = new ethers.Contract(pairAddress, ThetaSwap.PAIR.abi, provider);
                    const pairBalance = await pairContract.balanceOf(walletAddress);

                    dispatch({
                        type: SET_PAIR_BALANCE,
                        pairAddress: pairAddress,
                        pairBalance: pairBalance.toString()
                    });
                }
            }
        },
        fetchPairTokensBalance(pairAddress, tokenA, tokenB) {
            return async (dispatch, getState) => {
                let provider = selectProvider(getState())

                const tokenContractA = new ethers.Contract(tokenA.address, ThetaSwap.TOKEN.abi, provider);
                const tokenContractB = new ethers.Contract(tokenB.address, ThetaSwap.TOKEN.abi, provider);
                const tokenBalanceA = await tokenContractA.balanceOf(pairAddress);
                const tokenBalanceB = await tokenContractB.balanceOf(pairAddress);

                dispatch({
                    type: SET_PAIR_TOKENS_BALANCE,
                    pairAddress: pairAddress,
                    tokenBalanceA: tokenBalanceA.toString(),
                    tokenBalanceB: tokenBalanceB.toString(),
                    tokenDecimalsA: tokenA.decimals,
                    tokenDecimalsB: tokenB.decimals,
                });

            }
        },
        fetchPairTotalSupply(pairAddress) {
            return async (dispatch, getState) => {
                let provider = selectProvider(getState())
                const pairContract = new ethers.Contract(pairAddress, ThetaSwap.PAIR.abi, provider);
                const totalSupply = await pairContract.totalSupply();

                dispatch({
                    type: SET_PAIR_TOTAL_SUPPLY,
                    pairAddress: pairAddress,
                    pairTotalSupply: totalSupply.toString()
                });
            }
        },
        fetchTfuelGrovePair: () => async (dispatch, getState) => {
            const pair = ThetaSwap.PAIRS.TFUEL_GROVE;
            await dispatch(Wallet.actions.fetchPairTokensBalance(pair.address, pair.tokenA, pair.tokenB));
            await dispatch(Wallet.actions.fetchPairBalance(pair.address));
            await dispatch(Wallet.actions.fetchPairTotalSupply(pair.address));

            return true;
        },
        swapTfuelForGrove: (amountInput, amountOutputExact) => async (dispatch, getState) => {
            try {
                showLoader('Loading...');
                const pair = ThetaSwap.PAIRS.TFUEL_GROVE;
                const tokenInput = pair.tokenA;
                const tokenOutput = pair.tokenB;
                const providerOrSigner = selectProvider(getState());
                const signer = providerOrSigner.getSigner();
                const address = await signer.getAddress();
                const routerContract = new ethers.Contract(ThetaSwap.V2_ROUTER.address, ThetaSwap.V2_ROUTER.abi, signer);

                const path = [tokenInput.address, tokenOutput.address];
                const amountInputMax = truncateToDigits(parseFloat(amountInput) + (amountInput * ThetaSwap.SETTINGS.SLIPPAGE_TOLERANCE), tokenInput.decimals)

                const overrides = {
                    value: ethers.utils.parseEther("" + amountInputMax)
                };

                await wrapSendTransaction( () => {
                    return routerContract.swapETHForExactTokens(
                        toWei(amountOutputExact, 18),
                        path,
                        address,
                        Date.now() + ThetaSwap.SETTINGS.TRANSACTION_DEADLINE_IN_MS,
                        overrides
                    )
                });
                await dispatch(Wallet.actions.getBalances());
                await dispatch(UIState.actions.hideModal(ModalTypes.GetMoreGrove));
                toast.success(`Swapped TFUEL for GROVE`);
            }
            catch (e){
                console.log(e);
                toast.error(`Failed to swap TFUEL for GROVE`);
            }
            finally {
                dispatch(UIState.actions.hideLoader());
            }
        },
        fetchClaimableAirdropStates: () => async (dispatch, getState) => {
            if(ContractAddresses.ClaimableAirdropChecker === '0x0'){
                console.log('ClaimableAirdropChecker contract not set');
                return;
            }

            const airdropContractAddresses = _.map(Airdrops, (a) => {
                return a.contract_address;
            });
            console.log('[fetchClaimableAirdropStates] airdropContractAddresses == ', airdropContractAddresses);
            const provider = selectProvider(getState());
            const signer = provider.getSigner();
            const address = await signer.getAddress();
            console.log('[fetchClaimableAirdropStates] provider == ', provider);
            console.log('[fetchClaimableAirdropStates] signer == ', signer);
            console.log('[fetchClaimableAirdropStates] address == ', address);
            if(_.isNil(signer)){
                console.log('ClaimableAirdropChecker no signer');
                return;
            }
            const claimingContract = new ethers.Contract(ContractAddresses.ClaimableAirdropChecker, ClaimableAirdropCheckerContract.abi, signer);
            const states = await claimingContract.check(airdropContractAddresses);
            const airdropStates = _.reduce(Airdrops, (current, a, idx) => {
                return {
                    ...current,
                    [a.contract_address]: {
                        isAllowed: states[idx][0],
                        hasClaimed: states[idx][1],
                    }
                }
            }, {});
            console.log('airdropStates == ', airdropStates);

            dispatch({
                type: SET_AIRDROP_STATES,
                airdropStates: airdropStates,
            });

            return airdropStates;
        },
        claimAirDrop: (airdropContractAddress, isToken = false, tokenAmount = null) => async (dispatch, getState) => {
            try {
                showLoader('Claiming...');
                const provider = selectProvider(getState());
                const signer = provider?.getSigner();
                if(_.isNil(signer)){
                    console.log('claimAirDrop: no signer');
                    dispatch(UIState.actions.showModal(ModalTypes.Login, {}));
                    return;
                }
                const claimingContract = new ethers.Contract(airdropContractAddress, GroveWarsClaimableAirdropContract.abi, signer);

                await wrapSendTransaction( () => {
                    return claimingContract.claim();
                });

                await dispatch(Wallet.actions.fetchClaimableAirdropStates());
                await dispatch(Wallet.actions.getBalances());
                dispatch(UIState.actions.hideModal(ModalTypes.Airdrop));

                if(isToken){
                    // Show modal to stake their GROVE
                    dispatch(UIState.actions.showModal(ModalTypes.Stake, {
                        defaultAmountToStake: tokenAmount,
                    }));
                }

                toast.success(`Claimed airdrop`);
            }
            catch (e){
                console.log(e);
                toast.error(`Failed to claim airdrop`);
            }
            finally {
                dispatch(UIState.actions.hideLoader());
            }
        },
        getAirdropStatus: (airdropContractAddress) => async (dispatch, getState) => {
            try {
                showLoader('Checking...');
                const provider = selectProvider(getState());
                const signer = provider?.getSigner();
                if(_.isNil(signer)){
                    console.log('getAirdropStatus: no signer');
                    return;
                }
                const claimingContract = new ethers.Contract(airdropContractAddress, GroveWarsClaimableAirdropContract.abi, signer);
                const status = await claimingContract.getAirdropStatus();
                console.log('getAirdropStatus: status == ', status);
                return status;
            }
            catch (e){
                console.log(e);
                toast.error(`Failed to claim airdrop`);
            }
            finally {
                dispatch(UIState.actions.hideLoader());
            }
        },
        depositStake: (amountWei) => async (dispatch, getState) => {
            try {
                if (STAKING_DISABLED) {
                    toast.error(`${SubchainGovernanceTokenSymbol} staking is temporarily paused.`);
                    return;
                }

                showLoader('Loading...');
                const provider = selectProvider(getState());
                const signer = provider.getSigner();
                const address = await signer.getAddress();
                const chainRegistrarOnMainchainContract = new ethers.Contract(ContractAddresses.ChainRegistrarOnMainchain, ChainRegistrarOnMainchainContract.abi, signer)
                const vsm = new ethers.Contract(ContractAddresses.VSM, ValidatorStakeManagerContract.abi, signer);
                const governanceToken = new ethers.Contract(ContractAddresses.GovernanceToken, GovernanceTokenContract.abi, signer);

                const validatorAddrs = await getValidatorAddresses(chainRegistrarOnMainchainContract);
                const validatorAddr = getValidatorAddressForAccount(address, validatorAddrs);

                const amountBN = ethers.BigNumber.from(amountWei);
                await checkTokenBalance(governanceToken, address, amountBN);
                await checkTokenApproval(governanceToken, address, vsm.address, amountBN);

                await wrapSendTransaction(() => {
                    return chainRegistrarOnMainchainContract.depositStake(SubchainId, validatorAddr, amountBN.toString());
                });

                await dispatch(Wallet.actions.getBalances());
                dispatch(UIState.actions.hideModal(ModalTypes.Stake));

                toast.success(`${SubchainGovernanceTokenSymbol} staked`);

                return true;
            } catch (e) {
                console.log(e);
                toast.error(`Failed to stake ${SubchainGovernanceTokenSymbol}`);
            } finally {
                dispatch(UIState.actions.hideLoader());
            }
        },
    },
    helpers: {
        getSwapData: (tokenAddressInput, tokenAddressOutput, amountInput, amountOutput, pair) => {
            const getPairTokenReserve = (pair, tokenAddress) => {
                if (!_.isEmpty(pair)) {
                    if (pair.tokenAddressA === tokenAddress) {
                        console.log('')
                        return pair.tokenBalanceA
                    } else {
                        return pair.tokenBalanceB
                    }
                }
            }
            const getAmountOut = (amountIn, reserveIn, reserveOut) => {
                if (amountIn === 0 || reserveIn === 0 || reserveOut === 0
                    || parseFloat(amountIn) > parseFloat(reserveIn)) return 0;
                const amountInWithFee = amountIn * 997;
                const numerator = amountInWithFee * reserveOut;
                const denominator = reserveIn * 1000 + amountInWithFee;
                return numerator / denominator;
            }
            const getAmountIn = (amountOut, reserveIn, reserveOut) => {
                if (amountOut === 0 || reserveIn === 0 || reserveOut === 0
                    || parseFloat(amountOut) > parseFloat(reserveOut)) return 0;
                const numerator = reserveIn * amountOut * 1000;
                const denominator = (reserveOut - amountOut) * 997;
                return (numerator / denominator);
            }

            let pairReserveIn = getPairTokenReserve(pair, tokenAddressInput);
            let pairReserveOut = getPairTokenReserve(pair, tokenAddressOutput);
            let calculatedInputAmount = truncateToDigits(getAmountIn(amountOutput, pairReserveIn, pairReserveOut));
            let calculatedOutputAmount = amountOutput;
            let tokenPrice = pairReserveIn / pairReserveOut;
            let amountLimit = parseFloat(calculatedInputAmount) + (ThetaSwap.SETTINGS.SLIPPAGE_TOLERANCE * calculatedInputAmount);

            return { pairReserveIn, pairReserveOut,
                calculatedInputAmount, calculatedOutputAmount,
                tokenPrice, amountLimit
            }
        },
    },

    spec: {
        connected: false,
        provider: null, //buildDefaultProvider(),
        signer: null,
        currentAccount: null,
        balances: {
            governanceTokenOnHand: '0',
            governanceTokenStaked: '0',
        },
        nftBalances: {

        },
        storeProducts: [],
        storeProductsByNFTContract: {},
        stakeWithdrawals: [],
        stakingAPY: 0, // estimate
        nftTokenIdsByCollectibleAddress: {
            [ContractAddresses.PineOGCommemorativeNFT]: [],
            [ContractAddresses.GroveWarsCommemorativeNFT]: [],
        },
        pairs: {
            [ThetaSwap.PAIRS.TFUEL_GROVE.address]: ThetaSwap.PAIRS.TFUEL_GROVE
        },
        airdropStates: {},
    },

    modelReducer: (state, type, body, action) => {
        if (action.url && action.result !== RequestState.SUCCESS)
            return state;

        if (type === SET_LOGIN_TYPE) {
            return {
                ...state,
                loginType: action.loginType
            }
        }
        if (type === SET_PROVIDER) {
            return {
                ...state,
                provider: action.provider,
            }
        }
        if (type === SET_ACCOUNT) {
            return {
                ...state,
                currentAccount: action.account,
            }
        }
        if (type === INIT_WALLET_COMPLETE) {
            return {
                ...state,
                connected: action.connected,
                provider: action.provider,
                signer: action.signer,
                currentAccount: action.currentAccount
            }
        }
        else if (type === SET_STORE_PRODUCTS){
            return {
                ...state,
                storeProducts: action.products,
                storeProductsByNFTContract: _.keyBy(action.products, (p) => {
                    return p?.nftContract?.toLowerCase()
                })
            }
        }
        else if (type === SET_BALANCES) {
            return {
                ...state,
                balances: {
                    ...state.balances,
                    ...action.balances
                },
                nftBalances: {
                    ...state.nftBalances,
                    ...action.nftBalances
                }
            }
        } else if (type === SET_STAKE_WITHDRAWLS) {
            return {
                ...state,
                stakeWithdrawals: action.stakeWithdrawals
            }
        }  else if (type === SET_BLOCK_NUMBER) {
            return {
                ...state,
                blockNumber: action.blockNumber,
                blockNumberUpdatedAt: new Date()
            }
        } else if(type === SET_STAKING_APY){
            return {
                ...state,
                stakingAPY: action.stakingAPY
            }
        }
        else if(type === SET_NFT_TOKEN_IDS){
            return {
                ...state,
                nftTokenIdsByCollectibleAddress: {
                    ...state.nftTokenIdsByCollectibleAddress,
                    [action.collectibleAddress]: action.tokenIds
                }
            }
        }
        else if(type === SET_PAIR_BALANCE){
            console.log('SET_PAIR_BALANCE :: action == ', action);

            return {
                ...state,
                pairs: {
                    ...state.pairs,
                    [action.pairAddress]: {
                        ...state.pairs[action.pairAddress],
                        userBalance: fromWei(action.pairBalance),
                    }
                },
            }

        }
        else if(type === SET_PAIR_TOTAL_SUPPLY){
            console.log('SET_PAIR_TOTAL_SUPPLY :: action == ', action);

            return {
                ...state,
                pairs: {
                    ...state.pairs,
                    [action.pairAddress]: {
                        ...state.pairs[action.pairAddress],
                        totalSupply: fromWei(action.pairTotalSupply),
                    }
                },
            }
        }
        else if(type === SET_PAIR_TOKENS_BALANCE) {

            console.log('SET_PAIR_TOKENS_BALANCE :: action == ', action);
            return {
                ...state,
                pairs: {
                    ...state.pairs,
                    [action.pairAddress]: {
                        ...state.pairs[action.pairAddress],
                        tokenBalanceA: fromWei(action.tokenBalanceA, action.tokenDecimalsA),
                        tokenBalanceB: fromWei(action.tokenBalanceB, action.tokenDecimalsB),
                    }
                },
            }
        }
        else if(type === SET_PAIR_ALLOWANCE){
            console.log('SET_PAIR_ALLOWANCE :: action == ', action);
            return {
                ...state,
                pairs: {
                    ...state.pairs,
                    [action.pairAddress]: {
                        ...state.pairs[action.pairAddress],
                        allowance: fromWei(action.allowance),
                    }
                }
            }
        }
        else if(type === SET_AIRDROP_STATES){
            return {
                ...state,
                airdropStates: action.airdropStates,
            }
        }

        return state;
    }
}
export default Wallet;
